import { Component, OnInit, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectItem } from 'primeng/api';

import { RegionsService } from '../../services/GI.Web.Services.g';
import { Dropdown } from 'primeng/primeng';

// References for implementing a component with 2-way [(ngModel)] binding:
// - https://blog.thoughtram.io/angular/2016/07/27/custom-form-controls-in-angular-2.html#implementing-controlvalueaccessor
// - https://angular.io/api/forms/ControlValueAccessor
// - https://blog.angularindepth.com/never-again-be-confused-when-implementing-controlvalueaccessor-in-angular-forms-93b9eee9ee83
/**
 * Wraps UI (p-dropdown) for Region Selection.
 */
@Component({
  selector: 'app-region-selection',
  templateUrl: './region-selection.component.html',
  styleUrls: ['./region-selection.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RegionSelectionComponent),
    multi: true
  }]
})
export class RegionSelectionComponent implements OnInit, ControlValueAccessor {
  private _regionDropdown: Dropdown;
  private _onChange: Function;
  private _onTouched: Function;

  @ViewChild(Dropdown) set regionDropdown(value: Dropdown) {
    this._regionDropdown = value;
    if (this._regionDropdown && this._onChange) {
      this._regionDropdown.registerOnChange(this._onChange);
      this._regionDropdown.registerOnTouched(this._onTouched);
    }
  }
  constructor(
    private _regionsService: RegionsService
  ) { }

  // Defaulting azureRegions to null so can use it as a flag to know when loaded
  public azureRegions: SelectItem[];
  public selectedRegion: String;
  public isDisabled: boolean;

  ngOnInit() {
    this.getAzureRegions();
  }

  writeValue(obj: any): void {
    this.selectedRegion = obj;
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  private getAzureRegions() {
    this._regionsService.getList().subscribe(optionList => {
      this.azureRegions = optionList.options.map(x =>
        ({ label: x.displayName, value: x.key }));
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/region-selection/region-selection.component.ts